module.exports = __webpack_public_path__ + "static/media/volum.54430034.svg";